import React from 'react';
import PropTypes from 'prop-types';
import LikeIcon from '../icons/LikeIcon';
import LikeSolidIcon from '../icons/LikeSolidIcon';
import DislikeIcon from '../icons/DislikeIcon';
import DislikeSolidIcon from '../icons/DislikeSolidIcon';

export default function LikeDislikeButton({
  likeCount,
  dislikeCount,
  liked,
  disliked,
  onToggleLike,
  onToggleDislike,
}) {
  return (
    <div className="flex items-center gap-x-6">
      <div className="flex gap-x-2">
        <button type="button" onClick={onToggleLike} disabled={!onToggleLike}>
          {liked ? <LikeSolidIcon /> : <LikeIcon />}
        </button>
        <p>{likeCount}</p>
      </div>
      <div className="flex gap-x-2">
        <button
          type="button"
          onClick={onToggleDislike}
          disabled={!onToggleDislike}>
          {disliked ? <DislikeSolidIcon /> : <DislikeIcon />}
        </button>
        <p>{dislikeCount}</p>
      </div>
    </div>
  );
}

LikeDislikeButton.propTypes = {
  likeCount: PropTypes.number.isRequired,
  dislikeCount: PropTypes.number.isRequired,
  liked: PropTypes.bool,
  disliked: PropTypes.bool,
  onToggleLike: PropTypes.func,
  onToggleDislike: PropTypes.func,
};

LikeDislikeButton.defaultProps = {
  liked: false,
  disliked: false,
  onToggleLike: undefined,
  onToggleDislike: undefined,
};
